import { Component } from '@angular/core';
import { BaseFormTableInlineEditComponent } from '../base/base-form-table-inline-edit.component';
import { DataAction } from '../../../enum/data-action.enum';
import { DialogReturnData } from '../../../models/dialog-return-data.model';

/**
 * 雙檔表單 inline edit 頁面的抽象類別，繼承 BaseFormTableInlineEditComponent
 *
 * @export
 * @abstract
 * @class SimpleDoubleInlineEditComponent
 * @extends {BaseFormTableInlineEditComponent}
 */
@Component({
  template: ''
})
export abstract class SimpleDoubleInlineEditComponent extends BaseFormTableInlineEditComponent {

  /**
   * inline edit 的刪除都變成清除，因為只是從畫面移除
   */
  // override rowDeleteChangeToClear: boolean = true;

  /**
   * 單頭取消後 inline edit 也要跟著取消
   */
  override async beforeMasterMenuDiscard(): Promise<boolean> {
    // console.log('SimpleDoubleInlineEditComponent beforeMasterMenuDiscard');
    if (this.isTableInEdit()) {
      const btnCancelEditableRow = this.elementRef.nativeElement.querySelector('#' + this.parseToId('btnCancelEditableRow'));
      if (btnCancelEditableRow) {
        btnCancelEditableRow.click();
      }
    }

    return true;
  }

  /**
   * 單頭存檔 inline edit 要先存檔
   */
  override async beforeMasterMenuSubmit(): Promise<boolean> {
    // console.log('SimpleDoubleInlineEditComponent beforeMasterMenuDiscard');
    if (this.isTableInEdit()) {
      const checked = await this.saveEditingRow();
      return checked.success;
    }

    return true;
  }

  /**
   * inline edit 沒有 Row Action 的按鈕。
   * 所以相關的 function 都實作 return。
   */
  override initExtraRowActionMenu(): void {
    return;
  }

  /**
   * inline edit 沒有 Row Action 的按鈕。
   * 所以相關的 function 都實作 return。
   */
  override setExtraRowActionMenuStatus(): void {
    return;
  }

  /**
   * 其實這個不應該在這 override，因為很多程式可能會用到。
   * 在這寫只是為了不影響既有程式。
   * 如果真的有需要請自己再 override 實做。
   */
  override afterDetailMenuStatusChange(): void {
    return;
  }

  /**
   * inline edit 不是開窗編輯。
   * 所以相關的 function 都實作 return。
   */
  override initDialogConfig(dataAction: DataAction): void {
    return;
  }

  /**
   * inline edit 不是開窗編輯。
   * 所以相關的 function 都實作 return。
   */
  override doExtraDetailDialogClose(returnData: DialogReturnData): void {
    return;
  }

  /**
   * inline edit 沒有 Row Action 的按鈕。
   */
  override async doRowActionDelete(): Promise<boolean> {
    return true;
  }

  /**
   * 按下刪除按鈕後，從 detailDatas 移除資料後還要做什麼。
   * @param deletedData 刪除的資料
   */
  override afterDeleteEditableRow(deletedData: any): void {
    return;
  }

  /**
   * Table 上方的功能選單 - Add 按下去後預設要做的事情。
   * (1) 先驗證單頭檢核通過
   * (2) 呼叫父類別的 detailMenuAddCommand()
   */
  override async detailMenuAddCommand(): Promise<void> {
    console.log('SimpleDoubleComponent detailMenuAddCommand');

    // 雙檔 inline edit 的新增要確定單頭都沒有錯誤後才能新增
    this.submitted = true;
    if (!this.formGroup.valid) {
      return;
    }

    super.detailMenuAddCommand();
  }

  /**
   * 為了避免影響既有程式，預設不提供批次刪除
   * 有需要的再自己 override
   */
  override async doDetailMenuBatchDelete(): Promise<boolean> {
    return true;
  }

  override async beforeSaveEditableRow(): Promise<boolean> {
    return true;
  }
}
